import getCookie from './getCookie'
import { routePaths as routes } from '../../utilities/routePaths'

/*
 * FETCH REQUEST
 * Reduces boilerplate for writing async actions
 */
export function fetchRequest(url, options, filePayload = false) {
  options.headers['X-CSRFToken'] = getCookie('csrftoken')
  // Prevents overriding the default headers applied to the FileUploader
  // Only required for POST and PUT requests. GET requests cause issues
  // with FileUploader headers.
  if (
    options.method &&
    options.method !== 'GET' &&
    !filePayload &&
    options.method !== 'DELETE'
  )
    options.headers['Content-Type'] = 'application/json'

  return fetch(url, options).then(
    response => {
      if (response.ok) {
        if (response.status != 204) return response.json()
      } else {
        throw new Error(`API Failure ${response.status}`)
      }
    },
    error => {
      throw new Error(error)
    }
  )
}

function postToApi(payload, url, filePayload = false) {
  const options = {
    method: 'POST',
    body: filePayload ? payload : JSON.stringify(payload),
    headers: {}
  }

  return fetchRequest(url, options, filePayload).then(json => {
    return json
  })
}

function deleteToApi(url, token) {
  const options = {
    method: 'DELETE',
    headers: { bearer: token }
  }

  return fetchRequest(url, options).catch(e => {
    if (e.message == 'API Failure 404') {
      return
    } else {
      throw e
    }
  })
}

export function postFeedback(feedback) {
  return postToApi(feedback, '/api/feedback/')
}

export function postRecaptcha(recaptcha) {
  return postToApi(recaptcha, '/recaptcha/')
}

export function postComplaint(complaint) {
  return postToApi(complaint, '/api/complaints/')
}

export function postDocument(document) {
  return postToApi(document, '/api/document/', true)
}

export function deleteDocument(id, token) {
  return deleteToApi(`/api/document/${id}`, token)
}

/*
 * Save the complaint object by posting to the API.
 * Redirect browser to nextURL, success or failure.
 */
// withRouter(
export function saveComplaint(complaint, history, successURL) {
  handlePostToApi(complaint, history, successURL, postComplaint)
}

export function processFeedback(feedback, history, successURL) {
  handlePostToApi(feedback, history, successURL, postFeedback)
}

export function getActiveFeatureSwitches() {
  const options = {
    method: 'GET',
    headers: {}
  }
  return fetchRequest('/api/switches/active/', options).then(json => {
    return json
  })
}

function handlePostToApi(payload, history, successURL, postMethod) {
  let nextURL = routes.badRequest
  if (payload.source === 'opdiv') nextURL = routes.badRequestSimple

  postMethod(payload)
    .then(json => {
      /*
       * On success:
       *   json is empty {}
       * When API service is not responding:
       *   json is {code: 502, error: "Bad gateway"}
       * When API is up but request data is bad, maybe string too long for DB:
       *   json is {code: 400, error: "Bad Request"}
       */
      if (json.code) {
        if (json.code === 201) {
          nextURL = successURL
        } else if (json.code >= 500) {
          nextURL = routes.badGateway
        }
      } else {
        // Assume success, since no error codes
        nextURL = successURL
      }
      history.push(nextURL)
    })
    .catch(() => {
      /*
       * When the proxy returns code 400:
       *   this error is thrown/caught
       */
      history.push(nextURL)
    })
}
